<template>
    <div class="flex flex-wrap">
        <div v-for="item in imagesArr" class="w-3/12">

            <div class="mr-5">

                <GalleryBoxDefaultState
                v-if="form.item_id != item.id"
                :item="item"
                :getEntityByLanguage="getEntityByLanguage"
                :form="form"
                :makeEditable="makeEditable"
                />

                <GalleryBoxEditingState
                v-if="form.item_id == item.id"
                :item="item"
                :getEntityByLanguage="getEntityByLanguage"
                :cancelEdit="() => form.item_id = null"
                :deleteItem="deleteItem"
                :delete_item_form="delete_item_form"
                :changeUploadBoxState="changeUploadBoxState"
                :form="form"
                :updateItem="updateItem"
                :handleChange="handleChange"
                />

            </div>

        </div>
    </div>
</template>

<script>
import GalleryBoxDefaultState from './GalleryBoxDefaultState';
import GalleryBoxEditingState from './GalleryBoxEditingState';

import {
	hasFileInNotFallbackLanguage,
	showPreventFallbackLangModal,
	unlinkGalleryItemsInAllLanguages,
	unlinkGalleryItemsByLanguage
} from '@/Pages/GlobalHelpers';

export default {
	components: {
        GalleryBoxDefaultState,
        GalleryBoxEditingState
	},
	props: [
		'current_language',
		'gallery',
		'updateGallery',
		'changeUploadBoxState',
		'form',
		'showPreventFallbackLangModal',
		'deleteInAllLanguagesGalleryImageFormRunning',
		'hidePreventFallbackLangModal'
	],
	data(){
		return{
			station_id: this.$page.props.station.data.id,
			language: null || this.$page.props.tour.data.fallback_language,
			imagesArr: [],
			delete_item_form: this.$inertia.form({
				_method: 'POST',
				id: null,
				language: null || this.$page.props.tour.data.fallback_language,
				fallback_language: this.$page.props.tour.data.fallback_language,
			}),
			files_for_delete_in_languages:[],
            number_of_language_for_file_to_delete: null,
		}
	},
	mounted(){
		this.makeImagesArrFromGallery(this.gallery);
	},
	watch:{
	    current_language: function (newState, oldState){
	        this.language = newState;
	        this.form.language = newState;
	        this.delete_item_form.language = newState;
            this.form.item_id = null;
	    },
	    gallery: function (newState, oldState){
	        this.makeImagesArrFromGallery(newState);
	    },
	    deleteInAllLanguagesGalleryImageFormRunning: function(newState, oldState){
	    	if(newState == true && this.delete_item_form.id){
		        this.unlinkGalleryItemsInAllLanguages();
		    }
	    }
    },
    methods: {
    	makeImagesArrFromGallery(galleryArr){
    		if( galleryArr == null )
    		{
    			return;
    		}
    		if( galleryArr.length == 0 )
    		{
    			this.imagesArr = [];
    			return;
    		}
    		let arr = [];
    		galleryArr.forEach(el => {
    			arr.push({
    				id: el.id,
    				title: el.title,
    				description: el.description,
    				image: el.image,
    			})
    			this.imagesArr = arr;
    		})
    	},
    	getEntityByLanguage(object, entity){
    		if(entity == 'image')
    		{
    			if( object.image.filter(el => el.language == this.language).length == 0 )
    			{
    				return null;
    			}

    			return object.image.filter(el => el.language == this.language)[0].first_file_path
    		}
    		if(entity == 'title')
    		{
    			return object.title && object.title.localized_text[this.language];
    		}
    		if(entity == 'description')
    		{
    			return object.description && object.description.localized_text[this.language]
    		}
    	},
    	makeEditable(item){
    		if(this.form.item_id == item.id)
    		{
    			this.form.item_id = null;
    			return;
    		}
    		this.form.item_id = item.id;
    		this.form.title = item.title.localized_text[this.language];
    		this.form.description = item.description.localized_text[this.language];
    	},
    	showUpdateButton(item){
    		if(item.id == this.form.item_id){
    			return true;
    		}
    		return false;
    	},
    	updateItem(e){
    		e.target.disabled = true;
    		this.form.post(route('station.update-gallery-item', this.form.item_id), {
              preserveScroll: true,
              onSuccess: () => {
                this.updateGallery();
                this.form.item_id = null;
                this.form.title = null;
                this.form.description = null;
                this.form.file = null;
                this.form.loaded_file_path = '';
                this.form.from_media_library_id = null;
              }
            });
    	},
    	handleChange(e){
    		if(e.target.name == 'title')
    		{
    			this.form.title = e.target.value;
    		}
    		if(e.target.name == 'description')
    		{
    			this.form.description = e.target.value;
    		}
    	},
    	onFilePicked(e){
        	this.form.file = e.target.files[0]
        },
      hasFileInNotFallbackLanguage:hasFileInNotFallbackLanguage,
      deleteItem(item){
      	this.delete_item_form.id = item.id;
      	if(this.hasFileInNotFallbackLanguage('gallery_image') == true)
      	{
      		this.showPreventFallbackLangModal('gallery_image');
      		return
      	}

      	this.delete_item_form.post(route('station.unlink-gallery-item', this.delete_item_form.id), {
          preserveScroll: true,
          onSuccess: () => {
            this.updateGallery();
            this.delete_item_form.id = null;
          }
        });
      },
      unlinkGalleryItemsInAllLanguages:unlinkGalleryItemsInAllLanguages,
      unlinkGalleryItemsByLanguage:unlinkGalleryItemsByLanguage,
    }
}
</script>
